import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAllEquipTypes = (state, { equipmentTypes }) => {
  if (!equipmentTypes) return state;
  return state.merge({ equipmentTypes });
};

const setEnergyConfigs = (state, { energyConfigs }) => {
  if (!energyConfigs) return state;
  return state.merge({ energyConfigs });
};

const setAll = (state, { allEquipment }) => {
  if (!allEquipment) return state;
  return state.merge({ allEquipment });
};

const setAllEquipments = (state, { allEquipmentsData }) => {
  if (!allEquipmentsData) return state;
  return state.merge({ allEquipmentsData });
};
// set equipment of unique device id
const setEquipmentUniqueDeviceId = (state, { uniqueDeviceIdData }) => {
  return state.merge({ uniqueDeviceIdData });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setEquipmentsByFactoryId = (state, { factoryEquipments }) => {
  return state.merge({ factoryEquipments });
};

const setIsJobAssigned = (state, { isJobAssigned }) => {
  return state.merge({ isJobAssigned });
};

const setAllPackingDevices = (state, { packingDeviceData }) => {
  return state.merge({ packingDeviceData });
};
const setIsPlcIdConnected = (state, { isPlcIdConnected }) => {
  return state.merge({ isPlcIdConnected });
};

const setAllVisionEquipments = (state, { allVisionEquipments }) => {
  if (!allVisionEquipments) return state;
  return state.merge({ allVisionEquipments });
};

const setEquipmentLinePosition = (state, { equipmentLinePosition }) => {
  return state.merge({ equipmentLinePosition });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL_EQUIPMENT_TYPES,
    actionFunction: setAllEquipTypes,
  },
  {
    actionType: ActionTypes.SET_ENERGY_CONFIGS,
    actionFunction: setEnergyConfigs,
  },
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_ALL_EQUIPMENTS,
    actionFunction: setAllEquipments,
  },
  {
    actionType: ActionTypes.SET_UNIQUE_DEVICE_ID_DATA,
    actionFunction: setEquipmentUniqueDeviceId,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENTS_BY_FACTORY_ID,
    actionFunction: setEquipmentsByFactoryId,
  },
  {
    actionType: ActionTypes.SET_IS_JOB_ASSIGNED,
    actionFunction: setIsJobAssigned,
  },
  {
    actionType: ActionTypes.SET_ALL_PACKING_DEVICES,
    actionFunction: setAllPackingDevices,
  },
  {
    actionType: ActionTypes.SET_IS_PLC_ID_CONNECTED,
    actionFunction: setIsPlcIdConnected,
  },
  {
    actionType: ActionTypes.SET_ALL_VISION_EQUIPMENTS,
    actionFunction: setAllVisionEquipments,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_LINE_POSITION,
    actionFunction: setEquipmentLinePosition,
  },
];
